import { useState, useEffect } from 'react';
import { getCustomers, getInquiries, getQuotations } from '../services/api';

function Dashboard() {
  const [stats, setStats] = useState({
    customers: 0,
    inquiries: 0,
    pendingInquiries: 0,
    quotations: 0,
    pendingQuotations: 0
  });

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const [customers, inquiries, quotations] = await Promise.all([
        getCustomers(),
        getInquiries(),
        getQuotations()
      ]);

      setStats({
        customers: customers.length,
        inquiries: inquiries.length,
        pendingInquiries: inquiries.filter(i => i.status === 'pending').length,
        quotations: quotations.length,
        pendingQuotations: quotations.filter(q => q.status === 'pending').length
      });
    } catch (error) {
      console.error('Error loading stats:', error);
    }
  };

  const statCardStyle = {
    background: 'white',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    minWidth: '200px',
    border: '1px solid #f0f0f0'
  };

  return (
    <div>
      <h1 style={{ marginBottom: '30px', color: '#3D1F1F' }}>Dashboard</h1>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '20px',
        marginBottom: '30px'
      }}>
        <div style={statCardStyle}>
          <h3 style={{ color: '#7f8c8d', fontSize: '14px', marginBottom: '10px' }}>Total Customers</h3>
          <p style={{ fontSize: '32px', fontWeight: 'bold', color: '#C8342B', margin: 0 }}>{stats.customers}</p>
        </div>

        <div style={statCardStyle}>
          <h3 style={{ color: '#7f8c8d', fontSize: '14px', marginBottom: '10px' }}>Total Inquiries</h3>
          <p style={{ fontSize: '32px', fontWeight: 'bold', color: '#C8342B', margin: 0 }}>{stats.inquiries}</p>
          <p style={{ fontSize: '12px', color: '#7f8c8d', marginTop: '5px' }}>
            {stats.pendingInquiries} pending
          </p>
        </div>
      </div>

      <div style={{
        background: 'white',
        borderRadius: '8px',
        padding: '20px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        border: '1px solid #f0f0f0'
      }}>
        <h2 style={{ color: '#3D1F1F', marginBottom: '15px' }}>Quick Actions</h2>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <a href="/customers" style={{
            padding: '10px 20px',
            background: '#C8342B',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '4px',
            fontSize: '14px',
            fontWeight: '500'
          }}>
            Add Customer
          </a>
          <a href="/inquiries" style={{
            padding: '10px 20px',
            background: '#3D1F1F',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '4px',
            fontSize: '14px',
            fontWeight: '500'
          }}>
            New Inquiry
          </a>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
